module.exports = __webpack_public_path__ + "static/media/ddami-nemo.291e5967.png";